import React from "react";
import styled from "styled-components";
import Heart from "./Heart";
import CtaButton from "../InstantCash/CtaButton";

/** Section 5. See Hero.styles.ts for the px-not-rem note. */
const Wrapper = styled.section`
  position: relative;
  overflow: hidden;
  background: var(--brand-ink);
  color: #fff;

  .heart {
    pointer-events: none;
    position: absolute;
    left: -24px;
    bottom: -24px;
    width: 160px;
    height: 160px;
    color: rgba(209, 31, 61, 0.25);

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .inner {
    position: relative;
    margin: 0 auto;
    max-width: 896px;
    padding: 80px 20px;
    text-align: center;
  }

  .heading {
    margin: 0;
    font-family: var(--brand-display);
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.1;
    color: #fff;
  }

  .copy {
    margin: 16px auto 0;
    max-width: 576px;
    font-size: 18px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.7);
  }

  .cta {
    margin-top: 32px;
  }

  @media screen and (min-width: 640px) {
    .heart {
      width: 224px;
      height: 224px;
    }
    .inner {
      padding: 80px 32px;
    }
    .heading {
      font-size: 48px;
    }
  }

  @media screen and (min-width: 1024px) {
    .inner {
      padding: 112px 32px;
    }
    .heading {
      font-size: 60px;
    }
  }
`;

const ClosingCta = () => (
  <Wrapper className="section-lp2-closing">
    <span className="heart" aria-hidden="true">
      <Heart />
    </span>
    <div className="inner">
      <h2 className="heading">Ready when you are.</h2>
      <p className="copy">
        Get an answer in 60 seconds. No obligation, no runaround.
      </p>
      <div className="cta">
        <CtaButton showArrow={false}>Check your approval</CtaButton>
      </div>
    </div>
  </Wrapper>
);

export default ClosingCta;
